import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { CitaContext } from '../../context/CitaContext';

const ServiciosCard = ({ servicio }) => {
  console.log('📦 servicio:', servicio);
  const navigate = useNavigate();
  const { setServicioSeleccionado } = useContext(CitaContext);

  const handleSeleccionarServicio = () => {
    setServicioSeleccionado(servicio);
    navigate('/agendar'); // Cambiado a '/agendar' para que coincida con la ruta en App.jsx
  };

  return (
    <div className="card" style={{
      width: '280px',
      backgroundColor: 'white',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 3px 10px rgba(106, 90, 205, 0.1)',
      border: '1px solid #eaeaea',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: '0 6px 15px rgba(106, 90, 205, 0.2)'
      }
    }}>
      <div style={{ padding: '15px', borderBottom: '1px solid #f0f0f0' }}>
        <div style={{

        }}>
          {servicio.imagen
            ? <img
              src={servicio.imagen}
              alt={servicio.titulo}
              style={{
                width: '100%',      
                height: '150px',        
                objectFit: 'cover',      
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px'
              }}
            />
            : <i className="fas fa-stethoscope" style={{ fontSize: '24px', color: '#6a5acd' }}></i>
          }
        </div>


        <h3 style={{
          marginTop: '0',
          marginBottom: '10px',
          color: '#444',
          fontSize: '18px',
          textAlign: 'center'
        }}>{servicio.titulo}</h3>
      </div>

      <div style={{ padding: '15px 15px 20px' }}>
        <p style={{
          color: '#666',
          fontSize: '14px',
          minHeight: '40px',
          marginTop: '0'
        }}>{servicio.descripcion}</p>

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '20px',
          paddingTop: '15px',
          borderTop: '1px dashed #eee'
        }}>
          <span style={{
            fontWeight: 'bold',
            fontSize: '20px',
            color: '#6a5acd'
          }}>${servicio.precio}</span>

          <button
            onClick={handleSeleccionarServicio}
            style={{
              background: '#6a5acd',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <i className="fas fa-calendar-plus"></i>
            Agendar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiciosCard;